import React, {
  createContext,
  useContext,
  type FC,
  type ReactNode,
} from 'react';

interface TranslationsNamespaceProviderProps {
  namespace: string;
  children: ReactNode;
}

export const TranslationsNamespaceContext = createContext<string>('');

const TranslationsNamespaceProvider: FC<TranslationsNamespaceProviderProps> = ({
  namespace,
  children,
}) => {
  return (
    <TranslationsNamespaceContext.Provider value={namespace}>
      {children}
    </TranslationsNamespaceContext.Provider>
  );
};

export const useTranslationsNamespace = () =>
  useContext(TranslationsNamespaceContext);

export default TranslationsNamespaceProvider;
